export default __webpack_public_path__ + "images/SQ.04e8d33.png";